export default __webpack_public_path__ + "static/media/image-3.ee25d2e5.gif";